import { FC } from "react";
import { BoxProps } from "@chakra-ui/react";
import { TopicPreview } from "sdk/topics";
import { routes } from "~/constants";
import { useAuthZ } from "~/hooks/useAuthZ";
import { usePrefetch } from "~/store/api";
import { sanityImageUrlBuilder } from "~/utils/sanityImageUrlBuilder";
import { DumbArticleCard } from "./DumbArticleCard";
import { useGetSizeProps } from "./useGetSizeProps";
import { ArticleCardType } from "./utils";

interface Props {
  dek?: string;
  hasBoxShadow?: boolean;
  heroImageAlt: string;
  heroImageSrc: string;
  isLocked: boolean;
  key?: string;
  onClick?: () => void;
  slug: string;
  styleProps?: {
    border?: BoxProps["border"];
  };
  title: string;
  topic: TopicPreview;
  type: ArticleCardType;
}

export const ArticleCard: FC<Props> = ({
  heroImageSrc,
  isLocked,
  slug,
  topic,
  ...props
}) => {
  const sizeProps = useGetSizeProps(props.type);
  const apiArticlesShow = usePrefetch("articlesShow");
  const { library: authZ } = useAuthZ();
  const url = sanityImageUrlBuilder
    .image(heroImageSrc)
    .width(sizeProps.heroImg.width * 2)
    .height(sizeProps.heroImg.height * 2)
    .fit("crop")
    .auto("format")
    .quality(100)
    .url();

  const prefetchArticle = (): void => {
    apiArticlesShow({ slug, topic: topic.slug });
  };
  const isArticleLocked = !authZ.canViewPaywalledArticles && isLocked;

  return (
    <DumbArticleCard
      linkPath={`${routes.library}/${topic.slug}/${slug}`}
      topic={topic}
      heroImageSrc={url}
      isLocked={isArticleLocked}
      onMouseOver={prefetchArticle}
      {...props}
    />
  );
};
